import type { FC } from 'react'

import { Avatar, Box, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

interface Props {
  label: string
  url: string
}

const AvatarWithTooltip: FC<Props> = ({ label, url }) => {
  const [open, toggle] = useToggle(false)

  return (
    <Tooltip.Alt
      attachment="top center"
      targetAttachment="bottom center"
      label={label}
      open={open}
      toggle={toggle}
    >
      <Box>
        <Avatar size="s48" label={label} url={url} />
      </Box>
    </Tooltip.Alt>
  )
}

export default AvatarWithTooltip
